import { buildQueryString, fetchWrapper } from '@/_helpers';

export const callCenterApi = {
    // Labels
    getLabels: ({ team: teamId, page = 1, limit = 50, sortBy = 'createdAt:desc' } = {}) => {
        const queryString = buildQueryString({
            team: teamId,
            page,
            limit,
            sortBy,
        });
        return fetchWrapper.get(`call-center/labels?${queryString}`);
    },
    createLabel: (data) => fetchWrapper.post('call-center/labels', data),
    updateLabel: (labelId, data) => fetchWrapper.patch(`call-center/labels/${labelId}`, data),
    deleteLabel: (labelId) => fetchWrapper.delete(`call-center/labels/${labelId}`),

    // Presets
    getPresets: ({ team: teamId, page = 1, limit = 50, sortBy = 'createdAt:desc' } = {}) => {
        const queryString = buildQueryString({
            team: teamId,
            page,
            limit,
            sortBy,
        });
        return fetchWrapper.get(`call-center/presets?${queryString}`);
    },
    createPreset: (data) => fetchWrapper.post('call-center/presets', data),
    updatePreset: (presetId, data) => fetchWrapper.patch(`call-center/presets/${presetId}`, data),
    deletePreset: (presetId) => fetchWrapper.delete(`call-center/presets/${presetId}`),

    // Contacts
    getContacts: ({ team } = {}) => fetchWrapper.get(`call-center/contacts?team=${team}`),

    // Calls
    getCalls: ({
        team: teamId,
        page = 1,
        limit = 50,
        sortBy = 'createdAt:desc',
        status,
        label,
        contact,
        preset,
    } = {}) => {
        const queryString = buildQueryString({
            team: teamId,
            page,
            limit,
            sortBy,
            status,
            label,
            contact,
            preset,
        });
        return fetchWrapper.get(`call-center/calls?${queryString}`);
    },
    createCall: (data) => fetchWrapper.post('call-center/calls', data),
    getCall: (callId) => fetchWrapper.get(`call-center/calls/${callId}`),
    updateCall: (callId, data) => fetchWrapper.patch(`call-center/calls/${callId}`, data),
    initiateCall: (callId) => fetchWrapper.post(`call-center/calls/${callId}/initiate`),
    endCall: (callId) => fetchWrapper.post(`call-center/calls/${callId}/end`),
    bargeIntoCall: (callId) => fetchWrapper.post(`call-center/calls/${callId}/barge-in`),
    listenToCall: (callId) => fetchWrapper.post(`call-center/calls/${callId}/listen`),
    bulkInitiateCalls: (data) => fetchWrapper.post('call-center/calls/bulk/initiate', data),

    // Call Events
    getCallEvents: (callId, params = {}) => fetchWrapper.get(`call-center/calls/${callId}/events`, params),

    // Transcripts
    getCallTranscripts: (callId, params = {}) => fetchWrapper.get(`call-center/calls/${callId}/transcripts`, params),
    searchTranscripts: (data) => fetchWrapper.post('call-center/transcripts/search', data),
};
